<template>
  <div class="game-clock-compact" v-if="timeData && timeData.duration > 0">
    <span
      class="game-clock__label"
      :class="{ 'game-clock__turn': timeData.isNextColor }"
    >
      {{ timeLeft | asMmSs }}
    </span>
  </div>
</template>

<script>
const TIMER_INTERVAL = 250;

import { toDateWithOffset, diffIn } from "vue-chess-shared/utils/date-helper";
import { cachedTimeOffset } from "@/utils/firebase-helper";

export default {
  name: "GameClock",

  props: {
    timeData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      moveTime: 0,
      timeLeft: null,
    };
  },

  mounted() {
    this.timerId = setInterval(() => {
      if (!this.timeData) {
        return;
      }

      if (this.timeLeft === null) {
        this.timeLeft = this.timeData.timeLeft;
      }

      if (!this.timeData.isNextColor || !this.timeData.shouldDeductTime) {
        this.timeLeft = this.timeData.timeLeft;
        this.moveTime = 0;
        return;
      }

      this.moveTime = diffIn(
        toDateWithOffset(cachedTimeOffset()),
        this.timeData.lastMoveTime,
        "second"
      );

      this.timeLeft = this.timeData.timeLeft - this.moveTime;
    }, TIMER_INTERVAL);
  },

  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>

<style scoped>
.game-clock {
  display: flex;
  margin: 10px;
  font-size: 3em;
  align-items: center;
  justify-content: center;
}

.game-clock__turn {
  color: red;
}
</style>
